<template>
  <div class="cdetail">
    <Header />
    <Nav />
    <div class="cdetail-banner">
      <img src="../assets/companydetail/banner.png" alt="">
    </div>
    <div class="pages">
      <div class="cdetail-menu">
        宏云课堂
        <img src="../assets/icon/right-gray.svg" alt="">
        机构列表
        <img src="../assets/icon/right-gray.svg" alt="">
        机构详情
      </div>
      <div class="cdetail-introduce">
      <img src="../assets/company/companylist1.png" alt="" class="cdetail-introduce-img">
      <div class="cdetail-introduce-content">
        <div class="cdetail-introduce-title">
          <h4>光环国际教育集团</h4>
          <div class="cdetail-introduce-online">
            <img src="../assets/companydetail/online.svg" alt="">
            <span>在线咨询</span>
          </div>
        </div>
        <div class="cdetail-introduce-num">
            <span><b>20</b>节课程</span>
            <span><b>99%</b>好评</span>
          </div>
        <div class="cdetail-introduce-art">
            <p>光环国际拥有一支卓越专家顾问团队，他们由具有多年在国内外从事项目管理工作的资深项目经理人组成。分别服务和研究于IT、通信、制造业、工程、电子、能源、金融、政府机构等行业。光环国际一如既往全力推动项目管理在中国的发展，以“诚信，专注，高效...</p>
            <div class="cdetail-introduce-more">查看更多<img src="../assets/companydetail/right.svg" alt=""></div>
          </div>
      </div>
    </div>
    
    <div class="cdetail-class">
      <h4>全部课程</h4>
      <div class="cdetail-list">
        <dl @click="goDetail">
          <dt><img src="../assets/home/list1img.png" /></dt>
          <dd>
            <h5>采购案例解析</h5>
            <p>讲师：吴小明 宏云机构 | 28课时</p>
            <div class="cdetail-list-time">
              <div class="left">
                <b><i>￥</i>399</b>
              </div>
              <div class="right">
                <img src="../assets/companydetail/car.svg" alt="">
                <span>立即购买</span>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt><img src="../assets/class/class2.png" /></dt>
          <dd>
            <h5>国有企业招标采购专业实务及案例分析</h5>
            <p>讲师：袁静 宏云机构 | 20课时</p>
            <div class="cdetail-list-time">
              <div class="left">
                <b><i>￥</i>499</b>
              </div>
              <div class="right">
                <img src="../assets/companydetail/car.svg" alt="">
                <span>立即购买</span>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt><img src="../assets/class/class9.png" /></dt>
          <dd>
            <h5>框架协议采购方式解读和政府购买服务要点解析</h5>
            <p>讲师：岳小川 宏云机构 | 28课时</p>
            <div class="cdetail-list-time">
              <div class="left">
                <b><i>￥</i>399</b>
              </div>
              <div class="right">
                <img src="../assets/companydetail/car.svg" alt="">
                <span>立即购买</span>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt><img src="../assets/class/class11.png" /></dt>
          <dd>
            <h5>施工标评审实务</h5>
            <p>讲师：何建新 宏云机构 | 18课时</p>
            <div class="cdetail-list-time">
              <div class="left">
                <b><i>￥</i>1099</b>
              </div>
              <div class="right">
                <img src="../assets/companydetail/car.svg" alt="">
                <span>立即购买</span>
              </div>
            </div>
          </dd>
        </dl>
      </div>
      <div class="cdetail-list m25">
        <dl>
          <dt><img src="../assets/class/class1.png" /></dt>
          <dd>
            <h5>国有企业采购全流程风险控制与热点问题解析系列课程</h5>
            <p>讲师：张志军 宏云机构 | 28课时</p>
            <div class="cdetail-list-time">
              <div class="left">
                <b><i>￥</i>1699</b>
              </div>
              <div class="right">
                <img src="../assets/companydetail/car.svg" alt="">
                <span>立即购买</span>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt><img src="../assets/class/class12.png" /></dt>
          <dd>
            <h5>国有企业招标采购合法合规与非招标采购实务操作及热点问题风...</h5>
            <p>讲师：刘玲 宏云机构 | 11课时</p>
            <div class="cdetail-list-time">
              <div class="left">
                <b><i>￥</i>328</b>
              </div>
              <div class="right">
                <img src="../assets/companydetail/car.svg" alt="">
                <span>立即购买</span>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt><img src="../assets/class/class3.png" /></dt>
          <dd>
            <h5><span>采购</span>国有企业采购管理规范、招标采购操作实务及采购文件示范文本使...</h5>
            <p>讲师：刘一迪 宏云机构 | 13课时</p>
            <div class="cdetail-list-time">
              <div class="left">
                <b><i>￥</i>736</b>
              </div>
              <div class="right">
                <img src="../assets/companydetail/car.svg" alt="">
                <span>立即购买</span>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt><img src="../assets/class/class7.png" /></dt>
          <dd>
            <h5><span>采购</span>政府采购专职从业人员线上培训班</h5>
            <p>讲师：安帅 宏云机构 | 6课时</p>
            <div class="cdetail-list-time">
              <div class="left">
                <b><i>￥</i>799</b>
              </div>
              <div class="right">
                <img src="../assets/companydetail/car.svg" alt="">
                <span>立即购买</span>
              </div>
            </div>
          </dd>
        </dl>
      </div>
    </div>
    </div>
    <Fixed/>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import Fixed from '@/components/Fixed.vue';
export default {
  name: "CompanyDetail",
  components: {
    Header,
    Nav,
    Footer,
    Fixed,
  },
  methods: {
    goDetail() {
      this.$router.push('/classDetails')
    }
  }
};
</script>

<style lang="less" scoped>
.cdetail {
  &-menu {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    padding-top: 40px;
    padding-bottom: 20px;
    img {
      margin-left: 4px;
      margin-right: 4px;
    }
  }
  &-banner {
    width: 100%;
    height: 282px;
    position: relative;
    img {
      height: 282px;
      width: 1920px;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
    }
  }
  &-introduce {
    width: 1300px;
    height: 155px;
    box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.06);
    border-radius: 4px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    // margin-top: -79px;
    position: relative;
    z-index: 1;
    background: url(../assets/companydetail/bg.png) no-repeat;
    background-size: 100% 100%;
    padding-left: 78px;
    box-sizing: border-box;
    &-img {
      width: 139px;
      height: 108px;
      border-radius: 4px;
    }
    &-content {
      margin-left: 18px;
    }
    &-title {
      display: flex;
      align-items: center;
      h4 {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #202429;
        line-height: 25px;  
      }
    }
    &-online {
      margin-left: 44px;
      display: flex;
      align-items: center;
      img {
        width: 15px;
        height: 15px;
      }
      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666C80;
        line-height: 17px;
        margin-left: 2px;    
      }
    }
    &-num {
      margin-top: 10px;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0F1419;
        line-height: 20px;
        margin-right: 24px;
        b {
          color: #586470;
        }
      }
    }
    &-art {
      margin-top: 6px;
      padding-right: 115px;
      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }
    }
    &-more {
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #FF7E20;
      line-height: 20px;  
      display: flex;
      align-items: center;
      position: absolute;
      right: 115px;
      bottom: 23px; 
      img {
        width: 12px;
        height: 12px;
      }
    }
  }
  &-class {
    width: 1300px;
    margin: 20px auto;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #EEEEEE;
    padding-bottom: 74px;
    h4 {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #202429;
      line-height: 64px; 
      border-bottom: 1px solid #eee;
      padding-left: 76px;
      margin-bottom: 38px;
    }
  }
  &-list {
    margin: 0 76px;
    display: flex;
    justify-content: space-between;
    dl {
      width: 269px;
      dt {
        line-height: 0;
        img {
          width: 269px;
          height: 154px;
        }
      }
      dd {
        padding: 0 12px;
        border: 1px solid #eeeeee;
        box-sizing: border-box;
        margin-top: -1px;
        padding-top: 17px;
        h5 {
          font-size: 13px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 23px;
          height: 46px;
        }
        p {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 19px;
          margin-top: 8px;
        }
      }
    }
    &-time {
      padding-top: 18px;
      margin: 17px 0;
      border-top: 1px solid #eee;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        b {
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #FF1D00;
          line-height: 17px;
          i {
            font-size: 12px;
            font-style: normal;
          }
        }
      }
      .right {
        display: flex;
        align-items: center;
        img {
          width: 18px;
          height: 18px;
        }
        span {
          font-size: 13px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #FF1D00;
          line-height: 18px;
          margin-left: 8px;
        }
      }
    }
  }
}
.m25 {
  margin-top: 25px;
}
</style>